import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { TYPE_SCORM } from 'utils/file/types';
export var STATUS_OPENED = 'opened';
export var STATUS_COMPLETED = 'completed';
export var STATUS_FAILED = 'failed';
export var STATUS_OPENED_ICON = 'eye-open';
export var STATUS_COMPLETED_ICON = 'ok';
export var STATUS_FAILED_ICON = 'x';
var settingsByStatus = _defineProperty(_defineProperty(_defineProperty({}, STATUS_OPENED, {
  color: 'neutral',
  icon: STATUS_OPENED_ICON,
  i18nLabelKey: 'actions_opened'
}), STATUS_COMPLETED, {
  color: 'positive',
  icon: STATUS_COMPLETED_ICON,
  i18nLabelKey: 'actions_done'
}), STATUS_FAILED, {
  color: 'negative',
  icon: STATUS_FAILED_ICON,
  i18nLabelKey: 'actions_failed'
});
export default function getUserAssetStatus(_ref) {
  var type = _ref.type,
    userContentStatus = _ref.userContentStatus,
    userScormAssetStatus = _ref.userScormAssetStatus;
  var status = userContentStatus;
  if (type === TYPE_SCORM && userContentStatus === STATUS_OPENED && userScormAssetStatus === STATUS_FAILED) {
    status = STATUS_FAILED;
  }
  var statusSettings = settingsByStatus[status];
  return _objectSpread({
    status: status
  }, statusSettings);
}